import request from '../../request'

export default {
  fetchExchangeRateSpecDate: async(fromCurrency, toCurrency, date, data, options = {}) => {
    if (fromCurrency === toCurrency) {
      return {
        code: 200,
        data: 1
      }
    }

    return request(
      {
        url: '/getCurrencyExchangeRateByCurrencyCode',
        method: 'get',
        desc: '获取指定日期汇率'
      },
      {
        ...data,
        fromCurrency,
        toCurrency,
        date
      },
      options
    )
  },
  /**
   * 获取插件等app最新版本一级下载地址
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchAppInfo: async(data = {}, options = {}) => {
    return request(
      {
        url: '/app/info',
        method: 'get',
        desc: '获取app信息'
      },
      data,
      options
    )
  }
}
